import { cn } from "@/lib/utils";

// EPD lifecycle state -> customer-facing label + palette (R1.3A-02: never "Draft EPD")
export const STATE_META = {
  DRAFT: { label: "EPD — In preparation", tone: "amber" },
  DATA_COLLECTION: { label: "EPD — In preparation", tone: "amber" },
  CALCULATION_PREVIEW_INCOMPLETE: { label: "EPD — Calculation preview", tone: "amber" },
  CALCULATION_COMPLETE: { label: "EPD — Calculated", tone: "blue" },
  REVIEW_READY: { label: "Platform Validated", tone: "blue" },
  SUBMITTED_FOR_VERIFICATION: { label: "Submitted for Verification", tone: "violet" },
  EXTERNAL_VERIFICATION: { label: "Under Independent Verification", tone: "violet" },
  APPROVED: { label: "Independently Verified", tone: "blue" },
  ISSUED: { label: "Issued", tone: "green" },
  SUPERSEDED: { label: "Superseded", tone: "gray" },
  EXPIRED: { label: "Expired", tone: "red" },
  VALID: { label: "Valid", tone: "green" },
};

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  blue: "bg-sky-50 text-sky-700 border-sky-200",
  violet: "bg-violet-50 text-violet-700 border-violet-200",
  gray: "bg-slate-100 text-slate-600 border-slate-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status, className, testid }) {
  const meta = STATE_META[status] || { label: status, tone: "gray" };
  return (
    <span
      data-testid={testid || `status-${String(status || "").toLowerCase()}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        TONES[meta.tone], className)}
    >
      {meta.label}
    </span>
  );
}

export function CheckPill({ status }) {
  const map = {
    pass: "bg-emerald-50 text-emerald-700 border-emerald-200",
    warn: "bg-amber-50 text-amber-700 border-amber-200",
    fail: "bg-red-50 text-red-700 border-red-200",
  };
  const label = { pass: "Complete", warn: "Warning", fail: "Incomplete" }[status] || status;
  return <span className={cn("inline-flex items-center rounded border px-2 py-0.5 text-xs font-medium", map[status])}>{label}</span>;
}
